import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Paper from '@material-ui/core/Paper';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import AlertsGrid from '../../components/AlertsGrid/AlertsGrid';

// Constants
import { APP_TITLE } from '../../utils/constants';
import { setRefreshAlertsRequested } from '../../store/Alerts/AlertsActions';
import { ApplicationState } from '../../store';
import Header from '../../components/Header/Header';
import { GetString } from '../../components/StringResourceManager';
import {
  LocaleInterface,
  locales,
} from '../../components/AlertsGrid/GridLocale';
import AlertsDateRangeSelector from '../../components/AlertsGrid/AlertsDateRangeSelector';

// Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperGrid: {
      marginTop: theme.spacing(7),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
  })
);

export default function Alerts() {
  const classes = useStyles();

  const dispatch: Dispatch<any> = useDispatch();

  const refreshRate: number = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.refreshRate
  );

  const selectedLanguage: string = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.selectedLanguage
  );

  const [currentLocale, setCurrentLocale] = React.useState<LocaleInterface>(
    locales[0]
  );

  useEffect(() => {
    if (selectedLanguage == 'English') {
      setCurrentLocale(locales[0]);
    } else if (selectedLanguage == 'French') {
      setCurrentLocale(locales[1]);
    }
  }, [selectedLanguage]);

  useEffect(() => {
    setRefreshAlertsRequested(dispatch, true);
    let timeoutId: any;
    if (refreshRate > 0) {
      timeoutId = setInterval(() => {
        if (refreshRate > 0) setRefreshAlertsRequested(dispatch, true);
      }, refreshRate);
    }

    return () => {
      clearInterval(timeoutId);
    };
  }, [refreshRate]);

  return (
    <>
      <Helmet>
        <title>
          {GetString('PAGE_TITLE_ALERTS')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header
        open={true}
        pageDisplayed={GetString('PAGE_TITLE_ALERTS_CURRENT')}
      />
      <Paper className={classes.paperGrid}>
        <AlertsDateRangeSelector />
        <AlertsGrid />
      </Paper>
    </>
  );
}
